import {IThemeIcons} from '../../architecture/sections/theme-icons.interface';
import {InfoIcon} from './icons/info.icon';


export const Casino888Icons: Partial<IThemeIcons> = {
    infoIcon: InfoIcon
}

